import { render, staticRenderFns } from "./ReviewDestination.vue?vue&type=template&id=24224ab8&scoped=true&"
import script from "./ReviewDestination.vue?vue&type=script&lang=js&"
export * from "./ReviewDestination.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDestination.vue?vue&type=style&index=0&id=24224ab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24224ab8",
  null
  
)

export default component.exports